import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { CountryDto } from "app/models";
import { Subscription } from "rxjs";

@Component({
    selector: 'player-country-filter',
    templateUrl: './player-country-filter.modal.html',
    styleUrls: ['./player-country-filter.modal.scss'],
})
export class PlayerCountryFilterModal implements OnInit, OnDestroy {
    
    @Input() countries: CountryDto[];

    selectedCountries: any = [];

    formGroup: FormGroup;

    filteredCountries: CountryDto[] = [];

    private valueChangeSubscription : Subscription;

    constructor(public activeModal: NgbActiveModal) {}

    ngOnDestroy(): void {

        this.valueChangeSubscription.unsubscribe();
    }
    
    ngOnInit(): void {
        this.formGroup = new FormGroup({
            searchTerm: new FormControl(),
        })

        this.valueChangeSubscription = this.formGroup.controls.searchTerm.valueChanges.subscribe(value => {this.searchCountries();})

        this.selectedCountries = [];

        this.countries.forEach(item => {
            this.filteredCountries.push(item);
        })

        this.clearFilter();
    }

   

    submit() {
        let result: CountryDto[] = [];

        this.countries.forEach(element => {
            if (this.selectedCountries[element.code])
                result.push(element);
        });

        this.activeModal.close(result);
    }


    toggleCountry(item: CountryDto) {
        this.selectedCountries[item.code] = !this.selectedCountries[item.code];
    }

    clearFilter() {
        this.countries.forEach(item => {
            this.selectedCountries[item.code] = false;
        })
    }

    searchCountries() {
        let val = this.formGroup.controls.searchTerm.value?.toLowerCase();

        this.filteredCountries = [];

        if (!val) {
                this.countries.forEach(item => {
                    this.filteredCountries.push(item);
                })
        } else {
                this.countries.forEach(item => {
                    if (item.code.toLowerCase().indexOf(val) >= 0 || item.name.toLowerCase().indexOf(val) >= 0)
                        this.filteredCountries.push(item);
                })
        }
    }
}